import React from "react";
import { commitmentReducer, initialState } from "./reducer";
import useThunkReducer from "../../HOC/useThunkReducer";

export const CommitmentContext = React.createContext();

const CommitmentContextWrapper = ({ children }) => {
  const [commitmentState, dispatch] = useThunkReducer(
    commitmentReducer,
    initialState
  );

  const value = {
    commitmentState,
    dispatch,
  };
  return (
    <CommitmentContext.Provider value={value}>
      {children}
    </CommitmentContext.Provider>
  );
};

export default CommitmentContextWrapper;
